<template>
  <div class="application-management-box">
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="ID" align="center" fixed></el-table-column>
      <el-table-column prop="" label="排序" align="center"></el-table-column>
      <el-table-column prop="" label="应用名称" align="center"></el-table-column>
      <el-table-column prop="cover" label="图标" align="center">
        <template slot-scope="scope">
          <img-load :width="'70px'" :height="'90px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="应用链接" align="center"></el-table-column>
      <el-table-column prop="" label="增加日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="active" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="250">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="applicationAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove(scope.row.id)"></el-button>
          <el-button type="primary" size="mini">上移</el-button>
          <el-button type="primary" size="mini">下移</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <application-action ref="applicationAction"></application-action>
  </div>
</template>
<script>
import API from '@/api'
import ApplicationAction from './components/applicationAction'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      imgUrl: baseConfig.imgUrl,
      params: {
        id: '',
        pageNumber: 1,
        pageSize: 10,
        enable: ''
      }
    }
  },
  created() {
    // this.getRankList()
  },
  components: {
    ApplicationAction
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 编辑弹窗
    applicationAction(type,data){
      this.$refs.applicationAction.open(type,data)
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editToday(type,row) {
      this.$refs.editToday.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
